module.exports = __webpack_public_path__ + "static/CULT-8d6fdfe788e07d9e6ec262798d56743e.jpg";